import { IconButton } from "@mui/material"
import { holidayColNm } from "./constant"
import { RemoveCircleRounded } from "resource/muiImport"
import dayjs from "dayjs"
import { driverColNm } from "constants/driverConstant"

export const columns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
  },
  {
    field: "DrvCd",
    headerName: driverColNm.DrvCd,
    width: 100,
  },
  {
    field: "FLNNm",
    headerName: "ชื่อ-สกุล",
    width: 160,
  },
  {
    field: "TukCd",
    headerName: "เลขรถ",
    width: 100,
  },
  
]

export const endColumns = [
  // {
  //   field: "Total",
  //   headerName: "รวม",
  //   width: 120,
  //   align: "left",
  //   headerAlign: "left",
  // },
  {
    field: "NumSts1",
    headerName: "มา",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "NumSts10",
    headerName: "สาย",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "NumSts101",
    headerName: "ลากิจ",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "NumSts102",
    headerName: "ป่วย",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "NumSts103",
    headerName: "พักร้อน",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "NumSts104",
    headerName: "ขาด",
    width: 50,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => value || "0",
  },
  {
    field: "TotalAbsent",
    headerName: "รวมไม่มา",
    width: 80,
    align: "center",
    headerAlign: "left",
    valueGetter: ({row})=> {
      const absent = row.NumSts101 + row.NumSts102 + row.NumSts103 + row.NumSts104
      return `${absent}/${row.NumSts1 + row.NumSts10 + absent}`
    },
    cellClassName: "total"
  },
  {
    field: "NumOverTemp",
    headerName: "Tempเกิน",
    width: 70,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => `${value}`,
    cellClassName: ({ value }) => value > 0 ? "temp-over" : ""
  },
  {
    field: "NumTemp",
    headerName: "Temp(ครั้ง)",
    width: 70,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => `${value}`,
  },
  {
    field: "NumOverAlc",
    headerName: "Alcเกิน",
    width: 60,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => `${value}`,
    cellClassName: ({ value }) => value > 0 ? "alcohol-over" : ""
  },
  {
    field: "NumAlc",
    headerName: "Alc(ครั้ง)",
    width: 60,
    align: "center",
    headerAlign: "left",
    valueFormatter: ({ value }) => `${value}`,
  }]

  export const holidayColumns = [
    {
      field: "No",
      headerName: "No.",
      width: 50,
      align: 'center',
    },
    {
      field: "HdayDte",
      headerName: holidayColNm.HdayDte,
      type: "date",
      editable: true,
      width: 100,
      valueFormatter: (params) => {
        return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
      },
    },
    {
      field: "HdayNm",
      headerName: holidayColNm.HdayNm,
      editable: true,
      width: 120,
    },
    {
      field: "Dscp",
      headerName: holidayColNm.Dscp,
      editable: true,
      flex: 1,
    },
    {
      field: "Delete",
      headerName: "",
      width: 40,
      renderCell: ()=><IconButton><RemoveCircleRounded color="action"/></IconButton> 
    }
  ]